module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chooose_group"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(0)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("不设限额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_approve"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_approve",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media group",
    on: {
      "click": function($event) {
        return _vm.updateApproveType(1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_2"
  }, [_vm._v("限额审批")]), _vm._v(" "), _c('div', {
    staticClass: "inputWrap"
  }, [(_vm.setApproveType === _vm.setSinglestrokeApproveType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approve.approveThreshold),
      expression: "approve.approveThreshold",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "threshold",
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.approve.approveThreshold)
    },
    on: {
      "blur": [_vm.resetWindow, function($event) {
        return _vm.$forceUpdate()
      }],
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "approveThreshold", $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setApproveType === _vm.setmouthApproveType) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approve.monthlyLimit),
      expression: "approve.monthlyLimit",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "threshold",
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.approve.monthlyLimit)
    },
    on: {
      "blur": [_vm.resetWindow, function($event) {
        return _vm.$forceUpdate()
      }],
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "monthlyLimit", $event.target.value.trim())
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_tagWrap"
  }, [_c('div', {
    staticClass: "tagWrap research-background-color",
    on: {
      "click": function($event) {
        return _vm.updateMemberApproveType()
      }
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoWrap"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("请选择审批原则")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31e3d66a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupComponents/ChooseApproveType2.vue
// module id = 1590
// module chunks = 8